import React from "react";

export const Prices = (props) => {
  return (
    <div id="prices">
      <div className="container">
        <div className="row">
          <div className="col-xs-12 col-md-6" style={{ marginBottom: "30px" }}>
            {" "}
            <img src="img/laatoitus.jpg" className="img-responsive" alt="" />{" "}
          </div>
          <div className="col-xs-12 col-md-6">
            <div className="about-text">
              <h2>Hinnasto:</h2>
              <h3>{props.data ? props.data.paragraph : "loading..."}</h3>
                <ul className="list-style">
                  {props.data
                    ? props.data.P2.map((d, i) => (
                      <li key={`${d}-${i}`}>
                        {d.srv}
                        <i style={{ marginLeft: '5px' }}>{d.price}</i> {/* Add margin to the left */}
                      </li>

                      ))
                    : "loading"}
                </ul>
                <div>
                  <h3>Huomioithan:</h3>
                    <div className="list-style">
                      <div>
                        <ul>
                          {props.data
                            ? props.data.note.map((d, i) => (
                                <li key={`${d}-${i}`}>{d}</li>
                              ))
                            : "loading"}
                        </ul>
                      </div>
                    </div>
                </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
